import React from "react";

const NODES = [
  { n: "01", label: "DIAGRAM / IaC" },
  { n: "02", label: "CONTEXT" },
  { n: "03", label: "ASSETS" },
  { n: "04", label: "FLOWS" },
  { n: "05", label: "STRIDE" },
  { n: "06", label: "ATTACK TREES" },
  { n: "07", label: "MITIGATIONS" },
  { n: "08", label: "COMPLIANCE" },
];

export default function FieldPlate() {
  const NODE_X = [60, 170, 280, 390, 500, 610, 720, 830];
  const NODE_Y = 85;
  const NODE_R = 6;

  /* Bright, high-contrast SVG colors */
  const lineColor = "#475569";      /* Slate 600 - clearly visible line */
  const accentColor = "#c4b5fd";     /* Purple 300 - glowing accent */
  const inkColor = "#ffffff";        /* White - bright node labels */
  const faintColor = "#94a3b8";      /* Slate 400 - step numbers */

  return (
    <section className="tfl-loop" aria-label="Agent pipeline loop diagram">
      <div className="tfl-loop__header">
        <div className="tfl-eyebrow" style={{ justifyContent: "center" }}>Continuous Pipeline Engine</div>
        <h2 className="tfl-display">
          ThreatForge is iterative, not one-shot.
        </h2>
        <p className="tfl-body-lg" style={{ maxWidth: "620px", margin: "0 auto" }}>
          Each stage in the pipeline is a checkpoint you can inspect, edit, or replay. When architecture updates, the loop runs again inheriting prior analysis.
        </p>
      </div>

      <div className="tfl-loop__figure">
        <svg viewBox="0 0 900 150" role="img" aria-label="Agent pipeline loop diagram">
          {/* Return path (dashed top line) */}
          <path
            d="M 830 45 L 60 45"
            fill="none"
            stroke={lineColor}
            strokeWidth="1.5"
            strokeDasharray="4 4"
          />
          <path
            d="M 72 45 L 60 45 L 68 39 M 60 45 L 68 51"
            fill="none"
            stroke={accentColor}
            strokeWidth="2"
          />

          {/* Forward main spine line */}
          <path
            d={`M ${NODE_X[0]} ${NODE_Y} L ${NODE_X[NODE_X.length - 1]} ${NODE_Y}`}
            fill="none"
            stroke={lineColor}
            strokeWidth="2"
          />

          {/* Nodes */}
          {NODES.map((node, i) => {
            const x = NODE_X[i];
            const isAccent = i === 0 || i === NODES.length - 1;
            const stroke = isAccent ? "#a78bfa" : "#38bdf8";
            const fill = isAccent ? "#7c3aed" : "#0f172a";

            return (
              <g key={node.n}>
                <circle cx={x} cy={NODE_Y} r={NODE_R} fill={fill} stroke={stroke} strokeWidth="2" />
                <text
                  x={x}
                  y={NODE_Y + 26}
                  textAnchor="middle"
                  fontFamily="var(--tfl-font-mono)"
                  fontSize="10"
                  fontWeight="600"
                  fill={faintColor}
                >
                  {node.n}
                </text>
                <text
                  x={x}
                  y={NODE_Y - 16}
                  textAnchor="middle"
                  fontFamily="var(--tfl-font-mono)"
                  fontSize="9.5"
                  letterSpacing="0.06em"
                  fill={isAccent ? accentColor : inkColor}
                  fontWeight={isAccent ? "700" : "600"}
                >
                  {node.label}
                </text>
              </g>
            );
          })}
        </svg>

        <div className="tfl-loop__caption">
          <span>Fig. 1 — Automated Threat Modeling Pipeline Engine v2.0</span>
          <span>Each stage executes independently · Average scan: 0.4s to 4s</span>
        </div>
      </div>
    </section>
  );
}
